<script lang="ts">
	import Modal from '$lib/modals/Modal.svelte'
	import { storeStockModal } from '$lib/js/stores'
	import { t } from 'svelte-i18n-lingui'
</script>

<Modal on:close={() => ($storeStockModal = '')} type="adapted">
	<div class="stock-modal">
		<div class="stock-modal__inner">
			<h2 class="title">{$t`There's not enough stock`}</h2>
			<p>
				{@html `Actualmente disponemos en total de <strong>${$storeStockModal} unidades</strong> de este producto.`}
			</p>
		</div>
	</div>
</Modal>

<style lang="scss">
	.stock-modal {
		max-width: 340px;

		h2 {
			margin-right: 60px;
			font-size: 18px;
		}
	}
</style>
